import axios from 'axios'

const userState = {
  details: null,
  isGetProfileRequested: false,
  favoriteBusinesses: null,
  submission: {
    isFormSubmitting: false,
    isSuccess: false,
    isError: false,
    isEditable: false,
  },
}

// getters
const getters = {
  isRentPlusUser: (state) => state.details && state.details.subscriptions
        && state.details.subscriptions.rent_plus
        && state.details.subscriptions.rent_plus.active,
  isGetProfileRequested: (state) => state.isGetProfileRequested,
}

// actions
const actions = {
  GET_USER_PROFILE({ commit, rootState }) {
    axios
      .get(`${rootState.api}/profile`)
      .then((res) => {
        commit('SET_USER_DETAILS', res.data.data)
      })
      .catch((error) => console.log(error))
      .finally(() => {
        commit('SET_IS_GET_PROFILE_REQUESTED', true)
      })
  },
  GET_FAVORITE_BUSINESSES({ commit, rootState }) {
    axios
      .get(`${rootState.api}/user/businesses`)
      .then((res) => {
        commit('SET_FAVORITE_BUSINESSES', res.data.data)
      })
      .catch((error) => console.log(error))
  },
  PUT_USER_INFO({ commit, rootState }, form) {
    commit('SET_FORM_SUBMIT')

    if (form.password) {
      axios
        .put(`${rootState.api}/profile`, {
          light: parseInt(form.light, 10),
          type: form.type,
          email: form.email,
          civility: parseInt(form.civility, 10),
          company_name: form.company_name,
          company_siret: form.company_siret,
          first_name: form.first_name,
          last_name: form.last_name,
          birthday: form.birthday.custom,
          birthplace: form.birthplace,
          address: form.address,
          city: form.city,
          postal_code: form.postal_code,
          country_id: form.country,
          tel: form.tel,
          licence_number: form.licence_number,
          licence_date: form.licence_date.custom,
          licence_place: form.licence_place,
          password: form.password,
          optin_email: form.optin_email,
          optin_sms: form.optin_sms,
        })
        .then((res) => {
          commit('SET_USER_DETAILS', res.data.data)
          return commit('SET_FORM_SUCCESS')
        })
        .catch(() => commit('SET_FORM_ERROR'))
    }
    axios
      .put(`${rootState.api}/profile`, {
        light: parseInt(form.light, 10),
        type: form.type,
        email: form.email,
        civility: parseInt(form.civility, 10),
        company_name: form.company_name,
        company_siret: form.company_siret,
        first_name: form.first_name,
        last_name: form.last_name,
        birthday: form.birthday.custom,
        birthplace: form.birthplace,
        address: form.address,
        city: form.city,
        postal_code: form.postal_code,
        country_id: form.country,
        tel: form.tel,
        licence_number: form.licence_number,
        licence_date: form.licence_date.custom,
        licence_place: form.licence_place,
        optin_email: form.optin_email,
        optin_sms: form.optin_sms,
      })
      .then((res) => {
        commit('SET_USER_DETAILS', res.data.data)
        commit('SET_FORM_SUCCESS')
        commit('SET_FORM_TOGGLE_FORM_EDITABLE')
      })
      .catch(() => {
        commit('SET_FORM_ERROR')
      })
  },
  DELETE_USER_ACCOUNT({ commit, rootState }) {
    axios.delete(`${rootState.api}/account/delete`)
      .then(() => {
        commit('auth/CLEAR_LOCAL_STORAGE', null, { root: true });
        window.location.href = '/';
      })
  },
}

// mutations
const mutations = {
  SET_USER_DETAILS(state, user) {
    state.details = user
  },
  SET_FAVORITE_BUSINESSES(state, businesses) {
    state.favoriteBusinesses = businesses
  },
  SET_FORM_SUBMIT(state) {
    state.submission.isFormSubmitting = true
  },
  SET_FORM_SUCCESS(state) {
    state.submission.isSuccess = true
    state.submission.isError = false
    state.submission.isFormSubmitting = false
  },
  SET_FORM_TOGGLE_FORM_EDITABLE(state) {
    state.submission.isEditable = !state.submission.isEditable
  },
  SET_FORM_ERROR(state) {
    state.submission.isSuccess = false
    state.submission.isError = false
    state.submission.isFormSubmitting = false
  },
  SET_IS_GET_PROFILE_REQUESTED(state, isRequested) {
    state.isGetProfileRequested = isRequested
  },
}

export default {
  namespaced: true,
  state: userState,
  getters,
  actions,
  mutations,
}
